(function () {
	'use strict';
	var $window = $(window),
		$question = $('.js-question'),
		mediaQuery = function () {
			var screen = (window.getComputedStyle) ? window.getComputedStyle(document.body, ':after').getPropertyValue('content') : '';
			return screen;
		},
		// function serves different settings for different resolutions
		// Get number of displayed reviews by screen size
		mediaQueryLogic = function () {
			if (mediaQuery() === '\'desktop\'' || mediaQuery() === "\"desktop\"" || mediaQuery() === "desktop") {
				return {
					graphWidth: 950
				};
			} else if (mediaQuery() === '\'custom\'' || mediaQuery() === "\"custom\"" || mediaQuery() === "custom") {
				return {
					graphWidth: 950
				};
			} else if (mediaQuery() === '\'tablet\'' || mediaQuery() === "\"tablet\"" || mediaQuery() === "tablet") {
				return {
					graphWidth: 600
				};
			} else {
				return {
					graphWidth: 300
				};
			}
		};

	// init functions
	mediaQueryLogic();

	// FAQ section accordion
	$question.on('click', function () {
		$question.removeClass('active');
		$(this).addClass('active');
	});


	/*  ----------------------------------
		Dynamic section - D3 graph
		---------------------------------- */
	var data,
		locale = window.avastGlobals.web.locale.substring(3),
		customLocales = ['us', 'fr', 'br', 'ru'],
		url = avastGlobals.web.RootPath + 'api/v1/threat-stats?from=2015-01-01&to=2050-07-07',
		$around = $('#around'),
		$global = $('.js-global'),
		$local = $('.js-local'),
		$additional = $('.js-additional'),
		$users = $('.js-users'),
		thMil = function (number) {
			var users = number.toString(),
				separator = avastGlobals.web.numberThousandSeparator,
				arr = [],
				usersLength = users.length,
				str = '',
				value;

			for (var i = Math.ceil(usersLength / 3); i > 0; i--) {
				value = users.substring(usersLength - 3, usersLength);
				usersLength = usersLength - 3;
				arr.unshift(value);
			}
			for (var j = 0; j < arr.length; j++) {
				str += arr[j] + separator;
			}
			if (separator === '') {
				return str.substring(0, str.length + 1);
			} else {
				return str.substring(0, str.length - 1);
			}
		},
		// Graph
		//margin = {top: 20, right: 20, bottom: 30, left: 40},
		margin = {top: 20, right: 0, bottom: 80, left: 150},
		width = 900 - margin.left - margin.right,
		height = 500 - margin.top - margin.bottom,
		x = d3.scale.ordinal().rangeRoundBands([0, width], .1),
		y = d3.scale.linear().range([height, 0]),
		xAxis = d3.svg.axis().scale(x).orient('bottom'),
		yAxis = d3.svg.axis().scale(y).orient('left'),
		svg = d3.select('#around .AVsizer').append('svg')
	.attr('class', 'js-graph')
	.attr('width', width + margin.left + margin.right)
	.attr('height', height + margin.top + margin.bottom)
	.append('g')
	.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')'),
		revealStats = function (processedData) {
			svg.selectAll('.bar')
				.data(processedData)
				.enter()
				.append('rect')
				.attr('class', 'bar')
				.attr('x', function(d) { return x(d.week); })
				.attr('width', x.rangeBand() - 7)
				.attr('y', function(d) { return height - .5; })
				.attr('height', 0)
				.transition().delay(function (d,i){ return i * 50;}).duration(1500)
				.ease('bounce')
				.attr('y', function(d) { return y(d.users); })
				.attr('height', function(d) { return height - y(d.users) - .5; });
		};





	// execution according to locale
	if (customLocales.indexOf(locale) === -1) {
		// do for all other locales
		locale = 'XX'; // worldwide statistic
		$additional.hide();
		$local.hide();
	} else {
		// do for custom locales
		locale = locale.toUpperCase();
		$global.hide();
	}

	// get data for graph and render it
	$.get(url, function (data) {
		// create array from data object for current country
		var processedData = [],
			$graph = $('.js-graph');
		for(var name in data) {
			processedData.push({week: name, users: data[name][locale].users});
		}

		// leave only last 30 items in array
		if (processedData.length > 30) {
			processedData = processedData.splice(processedData.length - 30);
		}

		// add data to sentences above graph with proper thousand milestones
		$users.html(thMil(processedData[processedData.length - 1].users));

		// Add graph
		x.domain(processedData.map(function(d) { return d.week; }));
		//y.domain([0, d3.max(processedData, function(d) { return d.users; })]);
		y.domain([0, d3.max(processedData, function(d) { return d.users / 6 + d.users; })]);

		svg.append('g')
			.attr('class', 'x axis')
		//.attr('transform', 'translate(0,' + height + ')')
			.attr('transform', 'translate(-3, 420)')
		//          .attr('transform', 'translate(-3, 460)')
			.call(xAxis);

		svg.append('g')
			.attr('class', 'y axis')
			.attr('transform', 'translate(0, 0)')
			.call(yAxis);

		// add circles to x axis
		d3.select('.x.axis')
			.selectAll('g.tick')
			.insert('circle', ':first-child')
			.attr('r', 5).style('fill', '#d2d3de');

		d3.selectAll('.x.axis g.tick text')
			.attr('y', 25);

		// Scroll to graph
		/*$window.on('scroll', function () {
			if ($around.offset().top + $around.height() - 300 < $window.scrollTop() + $window.height()) {
				revealStats(processedData);
			}
		});*/

		// Responsive graph
		//      $window.on('resize', function () {
		//          $graph.attr('width', mediaQueryLogic().graphWidth);
		//      });
		//      $graph.attr('width', mediaQueryLogic().graphWidth);

		// on page load in viewport
		/*if ($around.offset().top + $around.height() - 300 < $window.scrollTop() + $window.height()) {
			revealStats(processedData);
		}*/
	});
})();

$(document).ready(function() {
	var browserRefs = ['google', 'bing'],
		$build = $('[data-alt-build]'),
		$anchors = $('[data-bi-download-name]');
		getReferrer = function () {
			var referrer = document.referrer;
			var path = referrer.split('/').filter(function (val) {
				return val.trim();
			});

			if (path.length > 1) {
				referrer = path[1];
			}

			if (referrer.length === 0) {
				return false;
			}

			return referrer;
		},
		validateReferrer = function (referrer) {
			var isValid = false;

			if (referrer) {
				$.each(browserRefs, function(key, el){
					if (referrer.indexOf(el) > -1) {
						isValid = true;
					}
				});
			}

			return isValid;
		},
		hasUTMs = function () {
			var url = window.location.href;
			if (url.indexOf('utm_campaign') > -1 || url.indexOf('gclid') > -1) {
				return true;
			} else {
				return false;
			}
		};

	var referrer = getReferrer();

	if (validateReferrer(referrer) && !hasUTMs()) {
		if ($anchors.length > 0 && $build.length > 0) {
			var build = $build.data('alt-build');

			$anchors.each(function(key, el){
				var oldBuild = $(el).data('bi-download-name');
				var href = $(el).attr('href').replace(oldBuild, build);

				$(el).attr('href', href);
				$(el).attr('data-bi-download-name', build);
			});
		}
	}

});


// FAQ structured data for Google search results
(function() {
	'use strict';
	var $ = avm.require('jquery'),
		$faq_holder = $('[data-structured-type="faq"]'),
		/* Function for JSON stringify and Script injection */
		jsonInjection = function(contextType, content){
			var el = document.createElement('script');
			var jsonIntro = {
					"@context": "http://schema.org",
					"@type": contextType
				},
				json = Object.assign(jsonIntro, content);

			el.type = 'application/ld+json';
			el.text = JSON.stringify(json);
			document.querySelector('head').appendChild(el);
		};

	$(document).ready(function(){
		//FAQ
		if ($faq_holder) {
			$faq_holder.each(function(){
				var contextType = 'FAQPage',
					$items = $(this).find('.accordion-item'),
					content = {},
					contentJson = [];

				$items.each(function() {
					contentJson.push({
						"@type": "Question",
						"name": this.querySelector('.accordion-title h4').innerText.replace(/\n/g,'').replace(/\t/g,''),
						"acceptedAnswer": {
							"@type": "Answer",
							"text": this.querySelector('.accordion-content').innerHTML.replace(/\n/g,'').replace(/\t/g,'')
						}
					})
				});
				content['mainEntity'] = contentJson;

				jsonInjection(contextType, content);
			});
		}
	});
})();
